module.exports = __webpack_public_path__ + "img/bg_icon_1.202a5d74.svg";